import React from "react";
import { FlapperSpinner } from "react-spinners-kit";
import "./index.css";

function Spinner({ text }) {
  return (
    <div className="spinner">
      <FlapperSpinner size={40} color="#2396BE" />
      <div className="loading-text">Уншиж байна...</div>
      <div style={{ fontWeight: 500, color: "gray" }}>{text}</div>
    </div>
  );
}

export default Spinner;
